// Port of api/fuel/app/classes/filter/search/games/sorts/query/play/date/first.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'

function getActiveName(filter) {
	if (sorted('played.first', filter) > 0) return 'played.first'
	if (sorted('played.first.all', filter) > 0) return 'played.first.all'
	if (sorted('played.first.context', filter) > 0) return 'played.first.context'
	return null
}

export default {
	name: 'played.first.*',
	post: false,
	require: function(config, filter) { return getActiveName(filter) !== null },
	run: function(config, filter, data, query) {
		var name = getActiveName(filter)
		query.leftjoin('p')
		query.order('MIN(p.play_date)', sortReverse(name, filter), sortPriority(name, filter))
		query.order('MIN(p.play_id)', sortReverse(name, filter), sortPriority(name, filter) + 0.1)
	}
}
